import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Box } from 'grommet/components/Box';
import { Tabs } from 'grommet/components/Tabs';
import { Tab } from 'grommet/components/Tab';
import { titleDatiResponsabile, titleDatiGestore, titleDatiRiepilogo, info } from '../Components/TitleDispute.js';
import data from '../Data.json';
import { ERRORMESSAGE } from '../Constants.js';
import DatiResponsabile from '../Components/DatiResponsabile';
import DatiGestore from '../Components/DatiGestore';
import DatiRiepilogo from '../Components/DatiRiepilogo';
/*import RegistrationResult from './RegistrationResult.js';*/
import { SearchPointOfSalesCtrl } from "../Controllers/Transaction/SearchPointOfSalesCtrl";
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
/*import { logout } from '../Utils/Utility';*/
import { SearchUserByPosCtrl } from '../Controllers/Ebox/SearchUserByPosCtrl';
import { SearchUserListBySocCtrl } from '../Controllers/Ebox/SearchUserListBySocCtrl';
import { SearchPosListCtrl } from '../Controllers/Ebox/SearchPosListCtrl';
import RegistrationResultEbox from '../Components/RegistrationResultEbox.js';



class Dispute extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            gestPage: 1,

            //VALUES DATI RESPONSABILE
            data: data,
            search: '',
            selected: {},
            value: [],
            checked: 'Y',
            checkedbox: '',
            openModal: false,
            openModalemail: false,
            codsocieta: sessionStorage.getItem('codesoc'),
            codSocietario: sessionStorage.getItem('codSocietario'),
            nome: '',
            cognome: '',
            telefono: '',
            fax: '',
            email: '',
            msgcodsoc: '',
            msgfax: '',
            msgemail: '',
            msgnumtel: '',
            statusResponse: '',
            //VALUES DATI GESTORE
            codes: [],
            emailGestore: '',
            usernamePV: [],
            selectedType: '',
            selectedUser: '',
            selectedPV: '',
            selectedCode: [],
            selectedUserPV: [],
            setEmailValue: [],
            msgemailGestore: '',
            openModalpoint: false,
            showGestore: true,
            showGestori: false,
            msgemailTable: [],
            tablePointofSales: [],
            pages:{},
            currentPage: 1,
            errorMails: false,
            listUsername: [],
            showTimeoutModal: false,
            desc: ''

        }

        //DATI RESPONSABILE METHODS
        this.setSearch = this.setSearch.bind(this);
        this.setForm = this.setForm.bind(this);
        this.validForm = this.validForm.bind(this);
        this.setRadioButton = this.setRadioButton.bind(this);
        this.setCheckbox = this.setCheckbox.bind(this);
        this.showModal = this.showModal.bind(this);
        this.showModalemail = this.showModalemail.bind(this);
        this.closeModal = this.closeModal.bind(this);

        //DATI GESTORE METHODS
        this.showModalemailGestore = this.showModalemailGestore.bind(this);
        this.showModalpointofsale = this.showModalpointofsale.bind(this);
        this.showGestori = this.showGestori.bind(this);
        this.showGestore = this.showGestore.bind(this);
        this.closeModalGestore = this.closeModalGestore.bind(this);
        this.setSelectionType = this.setSelectionType.bind(this);
        this.setSelectionPv = this.setSelectionPv.bind(this);
        this.setSelectionUser = this.setSelectionUser.bind(this);
        this.setSelectionCode = this.setSelectionCode.bind(this);
        this.setSelectionUserPV = this.setSelectionUserPV.bind(this);
        this.emailGestore = this.emailGestore.bind(this);
        this.setEmail = this.setEmail.bind(this);
        this.goToDispute = this.goToDispute.bind(this);
        this.setStatusResponse = this.setStatusResponse.bind(this);
    }


    componentDidMount() {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;
        SearchPointOfSalesCtrl(function (data, pages, currentPage) {
            self.setState({
                tablePointofSales: data === undefined ? [] : data,
                pages: pages === undefined ? [] : pages,
                currentPage: currentPage === undefined ? [] : currentPage
            });
        }, function (error) {
            self.setState({
                status: error
            }, function () {
                if (this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403) {
                    this.props.history.push({
                        pathname: '/ErrorPage',
                        state: this.state
                    })
                } else if (this.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                    // logout();
                    // this.props.history.push({
                    //     pathname: '/login'
                    // })
                }
            })

        }, token, ids, this.state.currentPage, this.state.search);

        SearchPosListCtrl(
            function (data) {
                self.setState({ codes: data !== '' ? data : [] })
            }, function (error) {
                if (this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403) {
                    this.props.history.push({
                        pathname: '/ErrorPage',
                        state: this.state
                    })
                } else if (this.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                    // logout();
                    // this.props.history.push({
                    //     pathname: '/login'
                    // })
                }

            }, token, ids)

    }

    //DATI RESPONSABILE METHODS
    setPoint(i) {

        const newSelected = this.state.selected;
        const newValue = this.state.value;
        newSelected[i] = !this.state.selected[i];
        newValue[i] = [i];

        this.setState({
            selected: newSelected,
            value: newValue
        })
    }

    setRadioButton(event) {
        this.setState({
            checked: event.target.value
        })
    }

    setCheckbox() {
        this.setState({
            checkedbox: !this.state.checkedbox
        })
    }

    setSearch(event) {
        this.setState({
            search: event.target.value
        })
    }

    setForm(event) {

        if (event.target.id === 'codsoc') {
            this.setState({
                codsocieta: event.target.value
            })
        } else if (event.target.id === 'nome') {
            this.setState({
                nome: event.target.value
            })
        } else if (event.target.id === 'cognome') {
            this.setState({
                cognome: event.target.value
            })
        } else if (event.target.id === 'numtel') {
            this.setState({
                telefono: event.target.value
            })
        } else if (event.target.id === 'fax') {
            this.setState({
                fax: event.target.value
            })
        } else if (event.target.id === 'email') {
            this.setState({
                email: event.target.value
            })
        }
    }

    validForm(event) {

        var email = this.state.email
        var tel = this.state.telefono
        var fax = this.state.fax

        //const emailreg = /^([a-zA-Z0-9_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})$/;
        const emailreg = /^([a-zA-Z0-9_.-]+)@([\da-zA-Z.-]+)\.([a-zA-Z.]{2,6})$/;
        var number = /^\d+$/;
        let phoneNumber = RegExp(/^\+(?:[0-9] ?){2,}[0-9]$/);


        if (event.target.id === 'email') {
            if (email !== '' && emailreg.test(email) === false) { // Validazione email
                this.setState({
                    msgemail: ERRORMESSAGE.msgemail,
                    email: ''
                })
            } else if (email !== '' && emailreg.test(email) === true) {
                this.setState({
                    msgemail: ''
                })
            }
        } else if (event.target.id === 'numtel') {
            if (tel !== '' && phoneNumber.test(tel) === false) { // Validazione numero telefono
                this.setState({
                    msgnumtel: ERRORMESSAGE.msgnumber,
                    telefono: ''
                })
            } else if (tel !== '' && phoneNumber.test(tel) === true) {
                this.setState({
                    msgnumtel: ''
                })
            }
        } else if (event.target.id === 'fax') {
            if (fax !== '' && number.test(fax) === false) { // Validazione fax
                this.setState({
                    msgfax: ERRORMESSAGE.msgnumber,
                    fax: ''
                })
            } else if (fax !== '' && number.test(fax) === true) {
                this.setState({
                    msgfax: ''
                })
            }
        }
    }

    showModal() {
        this.setState({
            openModal: true
        })
    }

    showModalemail() {
        this.setState({
            openModalemail: true
        })
    }

    closeModal() {
        this.setState({
            openModal: false,
            openModalemail: false
        })
    }

    nextStep = () => {
        const { step, gestPage } = this.state
        this.setState({
            step: step + 1,
            gestPage: gestPage + 1
        })
    }
    goToDispute() {
        this.props.location.push('/DisputeOnline')
    }

    prevStep = () => {
        const { step, gestPage } = this.state
        this.setState({
            step: step - 1,
            gestPage: gestPage - 1
        })
    }


    //DATI GESTORE 

    showModalemailGestore() {
        this.setState({
            openModalemail: true
        })
    }

    showModalpointofsale() {
        this.setState({
            openModalpoint: true
        })
    }

    closeModalGestore() {
        this.setState({
            openModal: false,
            openModalemail: false,
            openModalpoint: false,
            gestPage: 2
        })
    }

    setSelectionType(event) {
        let token = sessionStorage.getItem('token')
        let ids = sessionStorage.getItem('ids')
        const self = this;
        this.setState({
            selectedType: event.value,
            selectedUser: ''
        }, function () {
            if (this.state.selectedType === 'Punto Vendita' && this.state.selectedPV !== '') {
                self.setState({desc: ''})
                SearchUserByPosCtrl(function (data) {
                    self.setState({ listUsername: data !== '' ? data : [] })

                }, function (error) {
                    if (error === 500 || error === 400 || error === 404 || error === 403) {
                        this.props.history.push({
                            pathname: '/ErrorPage',
                            state: this.state
                        })
                    } else if (error === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                        // logout();
                        // this.props.history.push({
                        //     pathname: '/login'
                        // })
                    }

                }, this.state.selectedPV, token, ids
                )
            }
            else if (this.state.selectedType === 'Società') {
                var name = JSON.parse(sessionStorage.getItem('dataWelcome')).name;
                var address = JSON.parse(sessionStorage.getItem('dataWelcome')).address;
                var zip = JSON.parse(sessionStorage.getItem('dataWelcome')).zip;
                var desc = `${name} ${ address} ${zip}`;
                self.setState({desc: desc});
                sessionStorage.setItem('desc', desc)
                SearchUserListBySocCtrl((data) => {
                    self.setState({ listUsername: data })
                }, (err) => {
                    if (err === 500 || err === 400 || err === 404 || err === 403) {
                        this.props.history.push({
                            pathname: '/ErrorPage',
                            state: this.state
                        })
                    } else if (err === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                        // logout();
                        // this.props.history.push({
                        //     pathname: '/login'
                        // })
                    }
                }, token, ids);
            }

        })
        if (this.state.selectedType !== '') {
            this.setState({
                selectedUser: ''
            })
        }
    }


    setSelectionPv(event) {
        const self = this;
        let token = sessionStorage.getItem('token')
        let ids = sessionStorage.getItem('ids')
        this.setState({
            selectedPV: event.value,
            desc: `${this.state.codes[event.selected].name} ${this.state.codes[event.selected].address} ${this.state.codes[event.selected].city}`
        },
            () => {
                SearchUserByPosCtrl((data) => {

                    self.setState({ listUsername: data !== '' ? data : [] })

                },
                    (error) => {
                        if (error === 500 || error === 400 || error === 404 || error === 403) {
                            this.props.history.push({
                                pathname: '/ErrorPage',
                                state: this.state
                            })
                        } else if (error === 401) {
                            this.setState({
                                showTimeoutModal: true
                            })
                            // logout();
                            // this.props.history.push({
                            //     pathname: '/login'
                            // })
                        }
                    }, this.state.selectedPV, token, ids
                )
            }
        )
        sessionStorage.setItem('desc', this.state.desc)
    }

    setSelectionUser(event) {
        this.setState({
            selectedUser: event.value
        })
    }

    emailGestore(event) {
        this.setState({
            emailGestore: event.target.value
        }, function () {
            this.validEmailGestore();
        })
    }

    validEmailGestore(event) {
        var emailGestore = this.state.emailGestore;
        //const emailreg = /^([a-zA-Z0-9_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})$/;
        const emailreg = /^([a-zA-Z0-9_.-]+)@([\da-zA-Z.-]+)\.([a-zA-Z.]{2,6})$/;

        if (emailGestore !== '' && emailreg.test(emailGestore) === false) {
            this.setState({
                msgemailGestore: true,
                emailGestore: ''
            })
        } else if (emailGestore !== '' && emailreg.test(emailGestore) === true) {
            this.setState({
                msgemailGestore: false
            })
        } else if (emailGestore === '') {
            this.setState({
                msgemailGestore: false
            })
        }
    }

    showGestori() {
        this.setState({
            showGestore: false,
            showGestori: true,
            gestPage: 4
        })
    }

    showGestore() {
        this.setState({
            showGestore: true,
            showGestori: false,
            gestPage: 2
        })
    }

    setSelectionCode(row, i, e) {
        i = row.index
        let selectedCodes = this.state.selectedCode;
        selectedCodes[i] = e.value;
        this.setState({
            selectedCode: selectedCodes
        })
    }

    setSelectionUserPV(row, i, e) {
        i = row.index
        let selectedUsersPV = this.state.selectedUserPV;
        selectedUsersPV[i] = e.value;
        this.setState({
            selectedUserPV: selectedUsersPV
        })
    }

    setEmail(row, i, e) {
        i = row.index;
        let setEmails = this.state.setEmailValue;
        setEmails[i] = e.target.value;

        this.setState({
            setEmailValue: setEmails
        }/*, function () {
            this.validEmailTable();
        }*/)
    }

    setStatusResponse(status) {
        this.setState({
            statusResponse: status
        })
    }

    validEmailTable() {
        let emails = this.state.setEmailValue;

        //const emailreg = /^([a-zA-Z0-9_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})$/;
        const emailreg = /^([a-zA-Z0-9_.-]+)@([\da-zA-Z.-]+)\.([a-zA-Z.]{2,6})$/;

        var isMailsWrong = false;

        emails.forEach((element, index) => {
            if (element !== '' && emailreg.test(element) === false) {
                isMailsWrong = true;
            }
        });

        this.setState({
            errorMails: isMailsWrong
        });

    }

    form(step) {

        //DATI RESPONSABILE
        const { gest, data, search, selected, value, checked, checkedbox, openModal, openModalemail,
            codsocieta, nome, cognome, telefono, fax, email, msgcodsoc, msgfax, msgemail, msgnumtel,
            //DATI GESTORE
            codes, emailGestore, msgemailGestore, usernamePV, selectedType, selectedUser, selectedPV, selectedCode, selectedUserPV, setEmailValue, showTimeoutModal,
            masgemail, openModalpoint, showGestore, showGestori, msgemailTable, errorMails, tablePointofSales, listUsername, statusResponse, desc, currentPage, pages } = this.state;

        //DATI RESPONSABILE
        const values = {
            gest, data, search, selected, value, checked, checkedbox, openModal, openModalemail,
            codsocieta, nome, cognome, telefono, fax, email, msgcodsoc, msgfax, msgemail, msgnumtel,
            //DATI GESTORE
            codes, emailGestore, msgemailGestore, usernamePV, selectedType, selectedUser, selectedPV, selectedCode, selectedUserPV, setEmailValue, showTimeoutModal,
            masgemail, openModalpoint, showGestore, showGestori, msgemailTable, errorMails, tablePointofSales, listUsername, statusResponse, desc, currentPage, pages
        };

        switch (step) {
            case 1:
                return <DatiResponsabile
                    nextStep={this.nextStep}
                    setSearch={this.setSearch}
                    setForm={this.setForm}
                    setRadioButton={this.setRadioButton}
                    validForm={this.validForm}
                    /*setRadioButton={this.setRadioButton}*/
                    setCheckbox={this.setCheckbox}
                    showModal={this.showModal}
                    showModalemail={this.showModalemail}
                    closeModal={this.closeModal}
                    values={values}
                />
            case 2:
                return <DatiGestore
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    showModalemailGestore={this.showModalemailGestore}
                    showModalpointofsale={this.showModalpointofsale}
                    showGestori={this.showGestori}
                    showGestore={this.showGestore}
                    setEmail={this.setEmail}
                    closeModalGestore={this.closeModalGestore}
                    closeModal={this.closeModal}
                    setSelectionType={this.setSelectionType}
                    setSelectionPv={this.setSelectionPv}
                    setSelectionUser={this.setSelectionUser}
                    setSelectionCode={this.setSelectionCode}
                    setSelectionUserPV={this.setSelectionUserPV}
                    emailGestore={this.emailGestore}
                    values={values}
                />
            case 3:
                return <DatiRiepilogo
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    setStatus={this.setStatusResponse}
                    values={values}
                />
            case 4:
                return <RegistrationResultEbox
                    values={values}
                />
            default:
                return null;
        }
    }



    render() {
        const { step } = this.state;


        return (

            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Box align='center' className='content dispute-page' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }}>

                    <Box className='contentbox'>
                        {this.state.step === 1 ? titleDatiResponsabile : this.state.step === 2 ? titleDatiGestore : this.state.step === 3 ? titleDatiRiepilogo : null}

                        <Box direction='row'>
                            <Tabs>
                                <Tab title='Informazioni'>
                                    {info}
                                </Tab>
                                {this.state.codSocietario === '1' ?
                                    <Tab title='Iscriviti'>
                                        {this.form(step)}
                                    </Tab> : null
                                }
                            </Tabs>
                        </Box>
                    </Box>

                </Box>
            </Box>
        )
    }
}
export default Dispute;